// extracted by mini-css-extract-plugin
module.exports = {"container":"_2Js8kFgHyj3r7Q5ZlcaTlp","groupsList":"_2-_7ESZrdtR5hiPDdwyFqP"};